/** What the page tells the Days card from outside it (one per itinerary page): the sentences
 *  its polite live region says when something else changed the days (a save brought days back
 *  that someone changed meanwhile), a ledger row asking for a field of a day that is closed
 *  (open it, then focus the field), and the real ids a save gave the days the draft added
 *  (the open day follows its new id). A store, not state: only the card listens. */
import type { RecordKey } from '@/features/records/draft/changeSet';

type Listener<T> = (value: T) => void;

class Topic<T> {
  private readonly listeners = new Set<Listener<T>>();

  listen(fn: Listener<T>): () => void {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }

  /** True when a listener took it. */
  emit(value: T): boolean {
    for (const l of [...this.listeners]) l(value);
    return this.listeners.size > 0;
  }
}

export class DaysChannel {
  /** A sentence for the card's live region. */
  readonly said = new Topic<string>();
  /** Open a day and focus one of its fields (a ledger row's). */
  readonly open = new Topic<{ rec: RecordKey; path: string }>();
  /** The real ids a save gave the new days: temporary id → id. */
  readonly created = new Topic<ReadonlyMap<number, number>>();
}
